module.exports = __webpack_public_path__ + "img/use_coupon.7dbd820d.png";